<section class="join_us">
  <article class="box">
    <h2>{{title}}</h2>
    <button (click)="openPop()">{{button}}</button>
  </article>
</section>
